<template>
  <WithLoading :method="deleteNegativeKeyword">
    <template slot-scope="{ isLoading, actionMethod }">
      <DeleteButton :is-loading="isLoading" @click="actionMethod" />
    </template>
  </WithLoading>
</template>
<script>
import DeleteButton from '@@/common/action-buttons/DeleteButton';
import WithLoading from '@@/common/WithLoading';

import { NegativeKeywords } from '@/api/api';

export default {
  name: 'DeleteBidButton',
  components: {
    DeleteButton,
    WithLoading,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  methods: {
    deleteNegativeKeyword() {
      return NegativeKeywords.deleteKeyword({
        itemId: this.id,
      })
        .then(({ body: { message } }) => {
          this.$message.success(message);

          this.$emit('deleted', this.id);
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
        });
    },
  },
};
</script>
